import { useCallback } from 'react'

import CheckIcon from '@/assets/icons/icon-check.svg'
import CloseIcon from '@/assets/icons/icon-close.svg'
import { Button } from '@/components/ui/button.tsx'
import { setIsCustomCategory } from '@/models/vault/categoryOptions.ts'

interface Props {
  onSaveOrder: () => void
  isSorting: boolean
}

export const CustomizeCategoryTitle = ({ onSaveOrder, isSorting }: Props) => {
  const handleDisableCustomCategory = useCallback(
    () => setIsCustomCategory(false),
    [],
  )

  return (
    <div className="-ml-2 mb-2 flex items-center justify-between py-2">
      <Button
        disabled={isSorting}
        variant="ghost"
        onClick={handleDisableCustomCategory}
      >
        <CloseIcon className="h-5 w-5" />
      </Button>
      <p className="font-medium text-primary-500">CUSTOMIZE ORDER</p>
      <Button
        disabled={isSorting}
        variant="ghost"
        onClick={onSaveOrder}
      >
        <CheckIcon className="h-5 w-5" />
      </Button>
    </div>
  )
}
